export const DEFAULT_MAX_CHARACTER_EXCERPT = 90;
export const EXCERPT_SUFFIX = '...';

export const ACCEPTED_VIDEO_FILES = `video/mp4, video/x-m4v, video/*`;
export const MAX_VIDEO_SIZE = 5000; // MB
